<template>
  <a-alert
    class="reject-list"
    :message="refuseTitTxt"
    type="warning"
    show-icon
  >
    <ul slot="description">
      <li>
        <div class="top">
          <span class="time">{{ moment(data.audit_time * 1000).format(dateFormat) }}</span>
          <span class="truename">{{ data.audit_truename }}</span>
          <span class="group fs-gray">[{{ data.audit_rolename }}
            <span v-if="data.audit_rolename && data.audit_groupname">/</span>
            <span v-if="data.audit_groupname">{{ data.audit_groupname }}</span>]
          </span>
        </div>
        <div class="content">
          {{ data.audit_reason }}
        </div>
      </li>
    </ul>
  </a-alert>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    data: {
      type: [Object, Array],
      default: () => { }
    }
  },
  data () {
    return {
      dateFormat: 'YYYY-MM-DD HH:mm:ss'
    }
  },
  computed: {
    refuseTitTxt () {
      return this.$t('message["544"]')
    }
  },
  methods: {
    moment
  }
}
</script>

<style lang="scss" scoped>
.ant-alert {
  margin: 24px 0;
}
.reject-list {
  .truename {
    margin: 0 5px;
  }
}
</style>
